/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { Image } from "@mui/icons-material";

const ImageDialogButton = ({ setOpen }) => {
    const { t } = useTranslation();
    return (
        <Button color='primary' variant='contained' onClick={() => setOpen(true)}>
            <Image style={{ marginRight: "8px" }} />
            {t("commons.selectImage")}
        </Button>
    );
};

export { ImageDialogButton };
